import React, {useEffect, useState} from 'react';
import {Card, CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import Select from "react-select";
import Switch from "react-bootstrap-switch";
import {moduleProvider} from "../../../providers/moduleProvider";
import {rolePermissionService} from "../../../jwt/_services";
import {showToastCustom} from "../../../components/toast/customToast";
import {ButtonAdd} from "../../../components/buttons/buttonsActions";
import {error, saveMsg, selectOption, success} from "../../../components/i18n/i18n";
import {useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";

export default function RolePermissionForm(props) {

    const [module, setModule] = useState(null);
    const [moduleOptions, setModuleOptions] = useState([]);
    const [role, setRole] = useState(props.role);
    const [allowSearch, setAllowSearch] = useState(true);
    const [allowEdit, setAllowEdit] = useState(true);
    const [allowDelete, setAllowDelete] = useState(true);
    const [allowAdd, setAllowAdd] = useState(true);
    const [allowGallery, setAllowGallery] = useState(true);
    const [allowSchedule, setAllowSchedule] = useState(true);
    const [allowSync, setAllowSync] = useState(true);
    const [allowPrices, setAllowPrices] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        moduleProvider.getOptions()
            .then(result => {
                if (result){
                    setModuleOptions(result);
                    if (props.role?.module) {
                        moduleProvider.getItem(module.id)
                            .then(data => {
                                setModule(data);
                                setLoading(false);
                            });
                    } else {
                        setLoading(false);
                    }
                } else {
                    setModuleOptions([]);
                    setLoading(false);
                }
            })
            .catch(_ => {
                setModuleOptions([]);
                setLoading(false);
            });
    }, []);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            role: props.role
        }
    });

    const onModuleChange = (value) => {
        setModule(value);
    }

    const onAllowSearchChange = () => {
        setAllowSearch(!allowSearch);
    }

    const onAllowAddChange = () => {
        setAllowAdd(!allowAdd);
    }

    const onAllowEditChange = () => {
        setAllowEdit(!allowEdit);
    }

    const onAllowDeleteChange = () => {
        setAllowDelete(!allowDelete);
    }

    const onAllowGalleryChange = () => {
        setAllowGallery(!allowGallery)
    }

    const onAllowScheduleChange = () => {
        setAllowSchedule(!allowSchedule)
    }

    const onAllowSyncChange = () => {
        setAllowSync(!allowSync)
    }

    const onAllowPricesChange = () => {
        setAllowPrices(!allowPrices)
    }

    const onSubmit = (data, _) => {
        if (module == null) {
            return showToastCustom(error, selectOption);
        }
        setLoading(true);
        const dataRequest = {
            role: role,
            module: module,
            allowSearch: allowSearch,
            allowAdd: allowAdd,
            allowEdit: allowEdit,
            allowDelete: allowDelete,
            allowGallery: allowGallery,
            allowSchedule: allowSchedule,
            allowSync: allowSync,
            allowPrices: allowPrices,
        };

        if (dataRequest) {
            //Save
            return rolePermissionService.saveItem(dataRequest)
                .then(_ => {
                    setLoading(false);
                    props.refreshList();
                    resetForm();
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const resetForm = () => {
        setRole(props.role)
        setModule(null);
        setAllowDelete(true);
        setAllowEdit(true);
        setAllowAdd(true);
        setAllowSearch(true);
        setAllowGallery(true);
        setAllowSchedule(true);
        setAllowSync(true);
        setAllowPrices(true);
        reset();
    }

    return (
        <Card>
            {loading && showLoader()}
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Nombre del rol</Label>
                                <Input type="authority" name="authority" placeholder="Nombre del rol"
                                       value={role?.authority}
                                       disabled/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Modulo</Label>
                                <Select name="module"
                                        value={module}
                                        options={moduleOptions}
                                        placeholder="Selecciona un Módulo"
                                        isSearchable={true}
                                        isClearable={true}
                                        innerRef={register}
                                        onChange={onModuleChange}/>
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label>Buscar</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={allowSearch}
                                        onChange={onAllowSearchChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label>Agregar</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={allowAdd}
                                        onChange={onAllowAddChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label>Editar</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={allowEdit}
                                        onChange={onAllowEditChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label>Borrar</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={allowDelete}
                                        onChange={onAllowDeleteChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label>Galeria</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={allowGallery}
                                        onChange={onAllowGalleryChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label>Horarios</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={allowSchedule}
                                        onChange={onAllowScheduleChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label>Sync. Firebase</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={allowSync}
                                        onChange={onAllowSyncChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label>Obtener precios</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={allowPrices}
                                        onChange={onAllowPricesChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonAdd/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>

        </Card>
    )
}